<template>
	<el-skeleton
		class="scheduler-skeleton-loading"
		style="width: 100%"
		:loading="true"
		animated
	>
		<template slot="template">
			<!-- Main Tabs -->
			<el-card class="mt-2 p-1" style="height: 65px">
				<el-row :gutter="20">
					<el-col :span="10">
						<el-row :gutter="20">
							<el-col :span="6">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" />
									</template>
								</el-skeleton>
							</el-col>
							<el-col :span="6">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" />
									</template>
								</el-skeleton>
							</el-col>
							<el-col :span="6">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" />
									</template>
								</el-skeleton>
							</el-col>
							<el-col :span="6">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" />
									</template>
								</el-skeleton>
							</el-col>
							<!-- <el-col :span="5">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" />
									</template>
								</el-skeleton>
							</el-col> -->
						</el-row>
					</el-col>
					<el-col :span="14"></el-col>
				</el-row>
			</el-card>
			<!-- Dashboard Tab -->
			<el-card class="mt-2 p-4" style="height: 150px">
				<el-row :gutter="20" class="mb-6">
					<el-col :span="4">
						<el-row :gutter="20">
							<el-col :span="12">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" />
									</template>
								</el-skeleton>
							</el-col>
							<el-col :span="12">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" />
									</template>
								</el-skeleton>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="20"></el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="18" :offset="3">
						<el-row :gutter="20">
							<el-col :span="4">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" style="height:40px" />
									</template>
								</el-skeleton>
							</el-col>
							<el-col :span="5">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" style="height:40px" />
									</template>
								</el-skeleton>
							</el-col>
							<el-col :span="5">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" style="height:40px" />
									</template>
								</el-skeleton>
							</el-col>
							<el-col :span="5">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" style="height:40px" />
									</template>
								</el-skeleton>
							</el-col>
							<el-col :span="5">
								<el-skeleton style="--el-skeleton-rect-size: 100%">
									<template #template>
										<el-skeleton-item variant="rect" style="height:40px" />
									</template>
								</el-skeleton>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</el-card>
			<el-card class="mt-2 p-4" style="">
				<el-row :gutter="20" class="my-2">
					<el-col :span="24">
						<el-skeleton-item
							variant="image"
							style="width: 100%; height: 300px"
						/>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="my-2">
					<el-col :span="12">
						<el-skeleton-item
							variant="image"
							style="width: 100%; height: 300px"
						/>
					</el-col>
					<el-col :span="12">
						<el-skeleton-item
							variant="image"
							style="width: 100%; height: 300px"
						/>
					</el-col>
				</el-row>
				<!-- Table Filter -->
				<el-row :gutter="20" class="my-6">
					<el-col :span="6">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="10"></el-col>
					<el-col :span="6">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="2">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
				</el-row>
				<!-- Table Skeleton -->
				<el-row :gutter="20" class="my-2">
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" style="height:30px" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" style="height:30px" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" style="height:30px" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" style="height:30px" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" style="height:30px" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" style="height:30px" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" style="height:30px" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" style="height:30px" />
							</template>
						</el-skeleton>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="my-2">
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="my-2">
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="my-2">
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="my-2">
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="my-2">
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="3">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
				</el-row>
				<!-- Pagination -->
				<el-row :gutter="20" class="mt-6 mb-2">
					<el-col :span="4">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="4" :offset="6">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
					<el-col :span="4" :offset="6">
						<el-skeleton style="--el-skeleton-rect-size: 100%">
							<template #template>
								<el-skeleton-item variant="rect" />
							</template>
						</el-skeleton>
					</el-col>
				</el-row>
				<!-- ./Table Skeleton -->
			</el-card>
		</template>
	</el-skeleton>
</template>

<script>
export default {
	name: "TaskSkeletonLoader",
};
</script>
